import styled from 'styled-components';

export const InputContainer = styled.div`
  display: block;
  position: relative;
  margin-top: ${({ marginTop }) => marginTop ?? '40'}px;

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 16px;
    letter-spacing: 0.032px;
    transition: 0.2s;
    font-weight: bold;
    z-index: 99;
    color: ${({ disabled }) => (disabled ? '#848484' : '#4d4d4d;')};
  }

  input,
  textArea {
    padding: 8px 16px;
    line-height: 24px;
    width: 100%;
    border: 1px solid #848484;
    border-color: ${({ error }) => (error ? '#b61817' : '#848484')};
    background-color: #ffffff;
    border-radius: 4px;
    color: #848484;
    transition: 0.2s;
    outline: 0;
    font-size: 16px;
    letter-spacing: 0.032px;
    min-height: 38px;
    box-sizing: border-box;

    &:focus {
      border: 1px solid black !important;
      border-color: ${({ error }) => (error ? '#b61817' : '#848484')};
    }

    &:disabled {
      background-color: #e8e8e8 !important;
      color: #848484;
      cursor: auto;
    }

    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px white inset;
      -webkit-text-fill-color: #848484;

      &:disabled {
        -webkit-box-shadow: 0 0 0 30px #e8e8e8 inset;
      }
    }
  }

  .right-icon {
    position: absolute;

    top: 36px;
    right: 12px;

    svg {
      fill: #4d4d4d;
    }
  }

  .charactersCount {
    font-size: 14px;

    margin-bottom: 0px;
    font-weight: normal;
    margin-top: 8;
  }

  .errorMessage {
    color: #b91c1c;
    margin-top: 8px;
    font-size: 13px;
    height: 14px;
  }
`;
